import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

const sanity = createClient({
  projectId: process.env.GATSBY_SANITY_PROJECT_ID || '',
  dataset: process.env.GATSBY_SANITY_DATASET || '',
  apiVersion: '2021-03-25',
  useCdn: false, // use latest data for static generation
})

export const sanityImageUrlBuilder = imageUrlBuilder(sanity)
export default sanity
